<template>
  <ui-aside-layout @close="$emit('close')" class="sidebar-ui-bubble">
    <template v-if="bubbleId" slot="title">Edit bubble</template>
    <template v-else slot="title">Create bubble</template>
    <template slot="description"
      >Define the global information of the bubble.
      <div class="mb-4">
        <div class="mb-1" v-if="fields.dateupdate">
          <span class="italic text-gray-500">Last update:</span>
          <span class="italic px-4 py-2 text-gray-500 ">{{ fields.dateupdate | date }}</span>
        </div>
      </div>
    </template>

    <template slot="content">
      <div class="mb-4">
        <div class="mb-1">
          <span class="font-bold">What is the name of this bubble?</span>
          <span class="italic text-gray-500">(required)</span>
        </div>

        <input
          v-model="fields.name"
          class="p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full"
        />
      </div>

      <div class="mb-4">
        <div class="mb-1">
          <span class="font-bold">What is the description of this bubble?</span>
        </div>

        <input
          v-model="fields.description"
          class="p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full"
        />
      </div>
      <div class="mb-4">
        <div class="mb-1">
          <span class="font-bold">What is the tag of this bubble?</span>
        </div>
        <tags
          :add-tags-on-space="true"
          placeholder=""
          class="tags-input-wrapper-default"
          v-model="fields.tags"
          :typeahead="true"
        ></tags>
      </div>

      <div class="mb-4 flex justify-between items-center">
        <div class="mb-1 mr-2">
          <span class="font-bold">What is the color of this bubble?</span>
          <span class="italic text-gray-500">(required)</span>
        </div>

        <swatches v-model="fields.color" row-length="6" show-border popover-to="left" colors="basic"></swatches>
      </div>

      <div class="mb-4">
        <div v-if="fields.type !== 'import'" class="flex items-center justify-between">
          <div class="mb-4 flex">
            <span class="font-bold">What is the rules of this bubble?</span>
            <span class="italic text-gray-500">(required)</span>
          </div>
          <div class="mb-4 flex items-center justify-end">
            <button
              @click="modals.isOpenedRequestTypeCreation = true"
              class="px-4 py-2 rounded border border-gray-200 text-gray-500 max-w-max shadow-sm hover:shadow-md"
            >
              +
            </button>
          </div>
        </div>
        <template v-if="fields.uuids && fields.uuids.length">
          <div class="rounded border overflow-y-auto mb-4">
            <div class="font-bold bg-gray-200 p-3 flex justify-between">
              <span>Import</span>
              <button class="text-gray-400" @click="fields.uuids = []"><font-awesome-icon icon="trash" /></button>
            </div>
            <div class="p-3">
              <span
                v-for="uuid in fields.uuids"
                :key="uuid"
                class="mr-1 mb-1 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 rounded bg-white text-gray-700 border"
              >
                {{ uuid }}
              </span>
            </div>
          </div>
        </template>
        <template v-if="fields.request.length">
          <div class="md:items-center pb-4 border border-gray-200 rounded mb-2">
            <template v-if="fields.type === 'import'">
              <p
                class="p-3 border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none  w-full"
              >
                This bubble is bubble import, You can't modify it. there are {{ fields.usercount }} users inside the
                bubble
              </p>
            </template>
            <template v-else>
              <div class="font-bold bg-gray-200 p-3 flex justify-between mb-2">
                <span>MATCH</span>
              </div>
              <div v-for="(request, index) in fields.request" :key="index" class="p-3" style="padding-bottom:0;">
                <div
                  class="flex w-full"
                  style="flex-flow: row nowrap;justify-content:space-between;padding: 0 0 12px 12px;"
                >
                  <p style="flex:1;display:flex;flex-flow: row wrap;">
                    <select
                      id="aggregator"
                      v-model="request.aggregator"
                      class="mr-1 mb-1 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 rounded bg-white text-gray-700 border"
                      v-autowidth="{ maxWidth: '960px', minWidth: '100px', comfortZone: 15 }"
                      style="margin-bottom: 0;"
                    >
                      <option value="SUM">Sum</option>
                      <option value="DAILYAVERAGE">Daily average</option>
                      <option value="WEEKLYAVERAGE">Weekly average</option>
                      <option value="MONTHLYAVERAGE">Monthly average</option>
                    </select>
                    <span style="display:flex;align-items:center;">on&nbsp;</span>
                    <input
                      :list="'action' + index"
                      v-model="request.actions"
                      class="mr-1 mb-1 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 rounded bg-white text-gray-700 border"
                      v-autowidth="{ maxWidth: '960px', minWidth: '100px', comfortZone: 15 }"
                      style="margin-bottom: 0;"
                    />
                    <datalist :id="'action' + index">
                      <option v-for="event in events" :key="event.id" :value="event.alias">{{ event.alias }}</option>
                    </datalist>
                    <select
                      v-model="request.comparator"
                      class="mr-1 mb-1 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 rounded bg-white text-gray-700 border"
                      style="margin-bottom: 0;"
                    >
                      <option value="$eq">=</option>
                      <option value="$gt">&gt;</option>
                      <option value="$lt">&lt;</option>
                    </select>
                    <input
                      v-model="request.tresholdvalue"
                      min="0"
                      type="number"
                      class="mr-1 mb-1 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 rounded bg-white text-gray-700 border"
                      v-autowidth="{ maxWidth: '960px', minWidth: '30px', comfortZone: 15 }"
                      style="margin-bottom: 0;"
                    />
                    <template v-if="request.datestart && request.dateend">
                      <div style="display:flex;flex-flow: row nowrap;">
                        <span style="display:flex;align-items:center;">between&nbsp;</span>
                        <el-date-picker
                          v-model="request.datestart"
                          @change="setDate($event, true, request)"
                          placeholder="Date de début"
                          :picker-options="dateStartTimestamp"
                          :unlink-panels="true"
                          :clearable="false"
                          class="m-0 flex sel-date-picker"
                        />
                        <span style="display:flex;align-items:center;">&nbsp;-&nbsp;</span>
                        <el-date-picker
                          v-model="request.dateend"
                          @change="setDate($event, false, request)"
                          placeholder="Date de fin"
                          :picker-options="dateEndTimestamp"
                          :unlink-panels="true"
                          :clearable="false"
                          class="m-0 flex sel-date-picker"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <span class="flex items-center">the&nbsp;</span>
                      <select
                        v-model="request.rollingdays"
                        id="rollingdays"
                        class="mr-1 mb-1 text-xs inline-flex items-center font-bold leading-sm uppercase px-2 py-1 rounded bg-white text-gray-700 border"
                        name="caBrands"
                      >
                        <option value="7" selected>7</option>
                        <option value="30">30</option>
                        <option value="90">90</option>
                      </select>
                      <span style="display:flex;align-items:center;"> last days</span>
                    </template>
                  </p>
                  <div style="display:flex;align-items:center;justify-content:center;width:15px;">
                    <button class="text-gray-400" @click="fields.request.splice(index, 1)">
                      <font-awesome-icon icon="trash" />
                    </button>
                  </div>
                </div>
                <span
                  v-if="index !== fields.request.length - 1"
                  style="display:flex;align-items:center;font-weight:bold;"
                >
                  AND
                </span>
              </div>
            </template>
          </div>
        </template>
        <common-box-empty
          v-if="!fields.request.length && !fields.uuids.length"
          title="No rules linked"
          message="You can create a rule by clicking on the button above."
        />
      </div>

      <bubbles-ui-modal-creation-rules
        v-if="modals.isOpenedRequestTypeCreation"
        :open="modals.isOpenedRequestTypeCreation"
        :import-enable="!fields.request.length"
        :request-enable="!fields.uuids.length"
        @useAdvertisorId="bool => (fields.byAdvertisorId = bool)"
        @close="
          () => {
            modals.isOpenedRequestTypeCreation = false
          }
        "
        @users="addImportedUsers"
        @request="
          request => {
            fields.request.push(request)
          }
        "
      />
      <template>
        <div v-if="wavesLinked || bannersLinked || npsLinked">
          <div class="mb-1">
            <span v-if="wavesLinked.length > 0 && bannersLinked.length > 0 && npsLinked.length > 0" class="font-bold"
              >Some Banners, Waves, and Surveys are linked to that bubble</span
            >
            <span v-else-if="wavesLinked.length > 0 && bannersLinked.length > 0" class="font-bold"
              >Some Banners and Waves are linked to that bubble</span
            >
            <span v-else-if="wavesLinked.length > 0 && npsLinked.length > 0" class="font-bold"
              >Some Waves and Surveys are linked to that bubble</span
            >
            <span v-else-if="bannersLinked.length > 0 && npsLinked.length > 0" class="font-bold"
              >Some Banners and Surveys are linked to that bubble</span
            >
            <span v-else-if="wavesLinked.length > 0" class="font-bold">Some Waves are linked to that bubble</span>
            <span v-else-if="bannersLinked.length > 0" class="font-bold">Some Banners are linked to that bubble</span>
            <span v-else-if="npsLinked.length > 0" class="font-bold">Some Surveys are linked to that bubble</span>
          </div>
          <div v-if="wavesLinked.length !== 0 || bannersLinked.length !== 0 || npsLinked.length !== 0">
            <table>
              <thead>
                <tr>
                  <th
                    class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase quarter"
                  >
                    Name
                  </th>
                  <th
                    class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase"
                  >
                    Code
                  </th>
                  <th
                    class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase"
                  >
                    Status
                  </th>
                  <th
                    class="px-4 py-1 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase"
                  >
                    Lien
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="wave in wavesLinked" :key="wave.id" class="py-5 bg-white text-sm">
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">
                    <div class="overflow">{{ wave.name }}</div>
                  </td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{ wave.code }}</td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{ wave.status }}</td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">
                    <router-link :to="{ name: 'Wave', params: { site: site.sitekey, id: wave.id } }"
                      ><font-awesome-icon icon="pencil-alt"></font-awesome-icon
                    ></router-link>
                  </td>
                </tr>
                <tr v-for="banner in bannersLinked" :key="banner.id" class="py-5 bg-white text-sm">
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">
                    <div class="overflow">{{ banner.name }}</div>
                  </td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{ banner.code }}</td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{ banner.status }}</td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">
                    <router-link :to="{ name: 'BannerEdit', params: { site: site.sitekey, id: banner.id } }"
                      ><font-awesome-icon icon="pencil-alt"></font-awesome-icon
                    ></router-link>
                  </td>
                </tr>
                <tr v-for="nps in npsLinked" :key="nps.id" class="py-5 bg-white text-sm">
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">
                    <div class="overflow">{{ nps.name }}</div>
                  </td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{ nps.code }}</td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">{{ nps.status }}</td>
                  <td class="px-4 py-1 border-b border-gray-200 bg-white text-sm">
                    <router-link :to="{ name: 'Survey', params: { site: site.sitekey, id: nps.id } }"
                      ><font-awesome-icon icon="pencil-alt"></font-awesome-icon
                    ></router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </template>

    <template slot="footer">
      <div class="px-10 pb-8 pt-10">
        <common-button
          v-if="enableUnlink && bubbleId"
          @click="$emit('unlink', bubbleId)"
          type="secondary"
          :fullWidth="true"
          >dissociate the bubble</common-button
        >

        <common-button
          @click="dupplicate()"
          v-if="bubbleId && fields.type !== 'import'"
          type="secondary"
          :fullWidth="true"
          >Register as a new bubble</common-button
        >

        <common-button
          @click="save()"
          type="primary"
          :fullWidth="true"
          :disabled="isDisabledRegisterButton"
          :is-loading="isLoading"
          >Register</common-button
        >
      </div>
    </template>
  </ui-aside-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import swatches from 'vue-swatches'

export default {
  name: 'BubblesUiSidebarCreate',

  props: {
    bubbleId: {
      type: String,
      required: false
    },
    enableUnlink: {
      type: Boolean,
      required: false
    },
    wavesLinked: {
      type: Array,
      required: false
    },
    bannersLinked: {
      type: Array,
      required: false
    },
    npsLinked: {
      type: Array,
      required: false
    }
  },
  components: {
    swatches
  },
  data() {
    return {
      isLoading: false,
      fields: {
        name: null,
        description: null,
        tags: [],
        dateupdate: null,
        type: 'action',
        color: '#4ECDC4',
        emails: [],
        request: [],
        aggregator: 'SUM',
        uuids: [],
        usercount: 0,
        byAdvertisorId: false
      },
      modals: {
        isOpenedRequestTypeCreation: false
      }
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('events', {
      events: 'events'
    }),

    ...mapGetters('bubbles', {
      getById: 'getById'
    }),

    bubble() {
      if (this.bubbleId) {
        return this.getById(this.bubbleId)
      }
    },

    dateStartTimestamp(request) {
      return {
        disabledDate: time => {
          if (request.dateend) {
            return time.getTime() > new Date(request.dateend).getTime()
          }
          return false
        }
      }
    },
    // disabled the rule  button if they are no field name
    isDisabledRulesBubblesButton() {
      if (!this.fields.name) {
        return false
      }
      return true
    },
    // disabled the register button if they are no field name and no rules
    isDisabledRegisterButton() {
      if ((this.fields.name && this.fields.uuids.length !== 0) || this.fields.request.length !== 0) {
        return false
      }
      return true
    },
    dateEndTimestamp(request) {
      return {
        disabledDate: time => {
          if (request.datestart) {
            return time.getTime() < new Date(request.datestart).getTime()
          }
          return false
        }
      }
    }
  },
  methods: {
    ...mapActions('bubbles', ['loadBubble', 'addBubble', 'updateBubble', 'removeBubble']),
    ...mapActions('events', ['loadEvents']),

    setDate(date, start, request) {
      request.rollingdays = null

      if (start && date !== null) {
        request.datestart = this._setDate(date, this.site.timezone, true)
      }

      if (!start && date !== null) {
        request.dateend = this._setDate(date, this.site.timezone, false)
      }

      if (!request.datestart || !request.dateend) {
        request.datestart = null
        request.dateend = null
      }
    },

    addRule() {
      // Show banner
      // this.fields.request.push({
      //   actions: ['CONNECT'],
      //   comparator: '$eq',
      //   tresholdvalue: 0,
      //   datestart: null,
      //   dateend: null,
      //   aggregator: 'SUM'
      // })
    },

    addImportedUsers(users) {
      this.fields.uuids.push(...users)
    },

    save() {
      this.isLoading = true
      this.prepareBubbleBeforeSave()
      let bubble = Object.assign(this.fields, {})
      if (this.bubbleId) {
        this.update(bubble)
      } else {
        this.create(bubble)
      }
    },
    prepareBubbleBeforeSave() {
      if (this.fields.uuids.length) {
        this.fields.type = 'import'
      } else {
        delete this.fields.type
      }
    },
    dupplicate() {
      this.isLoading = true
      this.prepareBubbleBeforeSave()
      let bubble = Object.assign(this.fields, {})
      this.create(bubble)
    },

    create(bubble) {
      if (bubble.request && bubble.request.length > 0 && bubble.request[0].datestart && bubble.request[0].dateend) {
        for (let index = 0; index < bubble.request.length; index++) {
          bubble.request[index].datestart = this._setDate(bubble.request[index].datestart, this.site.timezone, true)
          bubble.request[index].dateend = this._setDate(bubble.request[index].dateend, this.site.timezone, false)
        }
      }

      this.addBubble({ bubble: bubble })
        .then(bubble => {
          this.isLoading = false

          if (bubble.request && bubble.request.length > 0 && bubble.request[0].datestart && bubble.request[0].dateend) {
            console.log(bubble.request)
            for (let index = 0; index < bubble.request.length; index++) {
              bubble.request[index].datestart = this._getDate(bubble.request[index].datestart, this.site.timezone)
              bubble.request[index].dateend = this._getDate(bubble.request[index].dateend, this.site.timezone)
            }
          }
          this.$emit('created-bubble', bubble)
          this.$emit('close')
        })
        .catch(response => {
          this.isLoading = false
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
        })

    },
    update(bubble) {
      console.log(bubble)
      if (bubble.request && bubble.request.length > 0 && bubble.request[0].datestart && bubble.request[0].dateend) {
        for (let index = 0; index < bubble.request.length; index++) {
          bubble.request[index].datestart = this._setDate(bubble.request[index].datestart, this.site.timezone, true)
          bubble.request[index].dateend = this._setDate(bubble.request[index].dateend, this.site.timezone, false)
        }
      }

      this.updateBubble({ bubble: bubble })
        .then(bubble => {
          this.isLoading = false

          if (bubble.request && bubble.request.length > 0 && bubble.request[0].datestart && bubble.request[0].dateend) {
            for (let index = 0; index < bubble.request.length; index++) {
              bubble.request[index].datestart = this._getDate(bubble.request[index].datestart, this.site.timezone)
              bubble.request[index].dateend = this._getDate(bubble.request[index].dateend, this.site.timezone)
            }
          }
          this.$emit('created-bubble', bubble)
          this.$emit('close')
        })
        .catch(response => {
          this.isLoading = false
          this.$notify.error({
            title: this.$root.$t('api.' + response.code + '.title'),
            message: this.$root.$t('api.' + response.code + '.message')
          })
        })
    }
  },

  mounted() {
    if (this.bubbleId) {
      this.loadBubble({ idBubble: this.bubbleId }).then(bubble => {
        this.fields = Object.assign(bubble, {})
        this.fields.uuids = []
      })
    }
    this.loadEvents()
  }
}
</script>

<style>
.tags-input-wrapper-default {
  max-height: 46px;
  padding: 0px;
  overflow-y: hidden;
}
.sel-date-picker {
  width: 150px;
  max-height: 26px;
}
.sidebar-ui-bubble .el-date-editor.el-input,
.sidebar-ui-bubble .el-date-editor.el-input__inner {
  width: 100%;
}
.overflow {
  overflow: hidden;
  height: 16px !important;
}
.quarter {
  width: 25%;
}
.el-input__prefix,
.el-input__prefix i,
.el-input__suffix,
.el-input__suffix span i,
.el-input__inner {
  display: flex;
  align-items: center;

  font-size: 12px;
  font-weight: 700;
  color: #374151;
}

.el-input__prefix,
.el-input__suffix {
  width: 15px;
}

p > div {
  margin-top: 10px;
}

ul.tabs li.is-active[data-v-85c5a11c]:after {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/bubbles/ui/sidebar/create.vue